import React, { useState, useEffect } from 'react';
import {
    Box,
    Badge,
    Text,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Spinner,
    useToast,
    HStack,
    VStack,
    Icon,
    Flex,
    Tag,
    useDisclosure,
    ModalFooter,
    Button,
    Tooltip,
    TableContainer,
    ModalBody,
    ModalCloseButton,
    ModalHeader,
    ModalContent,
    ModalOverlay,
    Center,
    Modal
} from '@chakra-ui/react';
import { ExternalLinkIcon, TimeIcon, WarningIcon } from '@chakra-ui/icons';
import {

    FaMobileAlt,

} from 'react-icons/fa';
import Pagination from 'react-js-pagination';
import moment from 'moment-timezone';
import API from '../../../helpers/axiosInstance';
import { getUserTimeZone } from '../../../utils/DefaultFunction';
import { LuBell, LuInbox, LuInfo, LuMail, LuMessageCircle, LuMessageSquare, LuPhone } from 'react-icons/lu';
import { fetchWrapper } from '../../../helpers';
import { useLocation } from 'react-router-dom';
import { Prism } from 'react-syntax-highlighter';

import { FiCheckCircle, FiXCircle } from 'react-icons/fi';
import EmailPreviewModal from '../../TemplateManager/CreateTemplate/EmailPreviewModal';
import { decodeHtmlEntities } from '../../TemplateManager/CreateTemplate/EmailDesigner/htmlExport';


const Channels = [
    { id: 1, name: 'SMS', icon: LuMessageSquare, color: '#3b82f6' },
    { id: 2, name: 'WhatsApp', icon: LuMessageCircle, color: '#25D366' },
    { id: 3, name: 'Email', icon: LuMail, color: '#f59e0b' },
    { id: 5, name: 'Push', icon: LuBell, color: '#ef4444' },
    { id: 6, name: 'In-App', icon: LuBell, color: '#8b5cf6' },
    { id: 7, name: 'Voice', icon: LuPhone, color: '#06b6d4' },
];

/**
 * `phone` and `email` are the contact's two possible identifiers — a contact is
 * created with either one (or both), so phone can legitimately be missing and the
 * message log has to be looked up by email instead. Phone stays preferred when
 * present: it is what the log is keyed on for every non-email channel.
 */
export function RecentMessagesTab({ phone, email }) {
    // Falls back to email only when there is no phone, so behaviour is unchanged
    // for the contacts that have one. Trimmed because a blank-but-present value
    // would otherwise search for whitespace and return nothing.
    const searchKey = (phone || '').trim() || (email || '').trim()

    // Main data states
    const [statusList, setStatusList] = useState([]);
    const [list, setList] = useState([])
    const [listCount, setListCount] = useState(0)
    const [loading, setLoading] = useState(false)
    const [activePage, setActivePage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [stats, setStats] = useState({
        count: 0,
        delivered_read: 0,
        msgFail: 0,
        msgSentCount: 0,
        success_rate: 0,
    });
    const [isOpen, setIsOpen] = useState(false);

    // Filter data states
    const [channelData, setChannelData] = useState([])
    const [statusData, setStatusData] = useState([])

    // Filter states
    const [showFilters, setShowFilters] = useState(false)

    // Applied filter states (sent to API)
    const [appliedChannel, setAppliedChannel] = useState(null)
    const [appliedStatus, setAppliedStatus] = useState(null)
    const [appliedStartDate, setAppliedStartDate] = useState('')
    const [appliedEndDate, setAppliedEndDate] = useState('')

    // Temporary filter states (for UI only, until Apply is clicked)
    const [selectedChannel, setSelectedChannel] = useState(null)
    const [selectedStatus, setSelectedStatus] = useState(null)
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [searchValue, setSearchValue] = useState('')
    const [debouncedSearchValue, setDebouncedSearchValue] = useState('')
    const [permissions, setPermissions] = useState([]);

    const [channelOptions, setchannelOptions] = useState([])
    const [statusOptions, setstatusOptions] = useState([])

    const user = JSON.parse(localStorage.getItem('customer'))

    const [selectedMessage, setSelectedMessage] = React.useState("");
    const [autoRefreshInterval, setAutoRefreshInterval] = useState(0);

    const [selectedPayload, setSelectedPayload] = useState(null);
    const customer_id = JSON.parse(localStorage.getItem("customer"))?.customer_id
    const {
        isOpen: isPayloadOpen,
        onOpen: onPayloadOpen,
        onClose: onPayloadClose,
    } = useDisclosure();
    const { isOpen: isErrorLogOpen, onOpen: onErrorLogOpen, onClose: onErrorLogClose } = useDisclosure();
    const [selectedErrorLog, setSelectedErrorLog] = useState(null);
    const [htmlPreview, setHtmlPreview] = useState(null);
    const [templatePreviewLoading, setTemplatePreviewLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const toast = useToast();
    const location = useLocation()



    const getApiHeaders = () => ({
        "x-api-key": localStorage.getItem('api-key'),
        "x-access-token": localStorage.getItem('customer-portal'),
    });

    /**
     * Fallback preview for a recorded body that cannot render.
     *
     * The log pipeline masks every digit in `message` to `****`, which destroys the HTML
     * beyond repair — `<h1>` becomes `<h****>`, `padding:16px` becomes `padding:****px`,
     * `border="0"` becomes `border="****"`, and every image URL containing a digit 404s.
     * `message_template_id` survives unmasked, so the source template can be fetched and
     * rendered to show what the email actually looks like.
     *
     * This is explicitly NOT what the recipient received — variables are unsubstituted and
     * a later template edit would show through — hence the note carried into the modal.
     */
    const loadTemplatePreview = async (templateId) => {
        if (!templateId) return;
        setTemplatePreviewLoading(true);
        try {
            const url = `${process.env.REACT_APP_API_URL}/template-message/get-by-id?id=${templateId}`;
            const res = await API.get(url, { headers: getApiHeaders() });
            const tpl = res?.data?.data || res?.data || {};
            let combine = {};
            try {
                combine = tpl.message_combine ? JSON.parse(tpl.message_combine) : {};
            } catch (e) {
                console.error('Failed to parse message_combine for template', templateId, e);
            }
            const html = decodeHtmlEntities(combine.emailHtml || combine.html_code || tpl.html_code || '');
            if (!html.trim()) {
                toast({ title: 'No email HTML stored on this template', status: 'warning', duration: 4000, isClosable: true });
                return;
            }
            setHtmlPreview((prev) => ({ ...prev, body: html, fromTemplate: true }));
        } catch (err) {
            toast({
                title: 'Could not load the template',
                description: err?.response?.data?.message || err?.message || 'Request failed',
                status: 'error',
                duration: 4000,
                isClosable: true,
            });
        } finally {
            setTemplatePreviewLoading(false);
        }
    };



    // Debounced search effect
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchValue(searchValue)
        }, 500) // 500ms delay

        return () => clearTimeout(timer)
    }, [searchValue])

    // Load data when applied filters or debounced search changes
    useEffect(() => {
        loadList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        appliedChannel,
        appliedStatus,
        appliedStartDate,
        appliedEndDate,
        debouncedSearchValue,
        activePage
    ])



    useEffect(() => {
        if (!autoRefreshInterval) return;

        const interval = setInterval(() => {
            loadList()
        }, autoRefreshInterval);

        return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoRefreshInterval, appliedChannel,
        appliedStatus,
        appliedStartDate,
        appliedEndDate,
        debouncedSearchValue,
        activePage]);


    // Initial data load
    useEffect(() => {
        loadChannelList()
        loadStatusList()
    }, [])

    const loadList = async () => {
        setLoading(true)

        try {
            const params = new URLSearchParams()

            // Required
            params.append("customer_id", user?.customer_id || "")

            params.append("search", searchKey)
            params.append("page", activePage)
            params.append("pageSize", "25")
            const url = `${process.env.REACT_APP_API_URL}/msg-log/list?${params.toString()}`

            const data = await fetchWrapper.get(url)

            const {
                count = 0,
                delivered_read = 0,
                msgFail = 0,
                msgSentCount = 0,
                success_rate = 0,
                data: listData = []
            } = data || {}

            setStats({ count, delivered_read, msgFail, msgSentCount, success_rate })
            setTotalItems(count)

            setList(listData)
            setListCount(count)

        } catch (error) {
            console.error("Error loading message logs:", error)
            setList([])
            setListCount(0)
        } finally {
            setLoading(false)
        }
    }



    const loadChannelList = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/channel/list`
            const data = await fetchWrapper.get(url)
            setChannelData(data.data || [])
            setchannelOptions(data.data.map((item) => {
                return {
                    label: item?.name,
                    value: item?.id
                }
            }))
        } catch (error) {
            console.error('Error loading channels:', error)
        }
    }

    const loadStatusList = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/status/list`
            const data = await fetchWrapper.get(url)
            setStatusData(data.data || [])
            setstatusOptions(data.data.map((item) => {
                return {
                    label: item?.name,
                    value: item?.id
                }
            }))
        } catch (error) {
            console.error('Error loading status list:', error)
        }
    }




    const applyFilters = () => {
        setAppliedChannel(selectedChannel)
        setAppliedStatus(selectedStatus)
        setAppliedStartDate(startDate)
        setAppliedEndDate(endDate)
        setActivePage(1)
        setShowFilters(false) // Hide filters after applying
    }

    const clearFilters = () => {
        // Clear temporary filter states
        setSelectedChannel(null)
        setSelectedStatus(null)
        setStartDate('')
        setEndDate('')

        // Clear applied filter states
        setAppliedChannel(null)
        setAppliedStatus(null)
        setAppliedStartDate('')
        setAppliedEndDate('')

        // Clear search
        setSearchValue('')
        setActivePage(1)
    }

    const toggleFilters = () => {
        setShowFilters(!showFilters)
    }






    const Channels = [
        {
            name: "Whatsapp",
            icon: LuMessageCircle,
            color: "#00a63e",
            description: "Rich messaging with media and buttons",
            id: 2,
        },
        {
            name: "SMS",
            icon: LuMessageSquare,
            color: "#155dfc",
            description: "Simple text messages",
            id: 1,
        },
        {
            name: "E-Mail",
            icon: LuMail,
            color: "#9810fa",
            description: "HTML emails with rich content",
            id: 3,
        },
        {
            name: "Push Notification",
            icon: LuBell,
            color: "#e60076",
            description: "Mobile app notifications",
            id: 6,
        },
        {
            name: "In-App Notification",
            icon: LuBell,
            color: "#4f39f6",
            description: "In-app messages and alerts",
            id: 5,
        },
        {
            name: "Voice (IVR)",
            icon: LuPhone,
            color: "#f54a00",
            description: "Automated voice calls",
            id: 4,
        },
    ];
    const getChannelInfo = (channelIdOrName) => {
        return (
            Channels.find(
                (c) => c.id === channelIdOrName || c.name === channelIdOrName
            ) || { name: "System", icon: FaMobileAlt, color: "gray" }
        );
    };


    const openModal = (msg) => {
        setSelectedMessage(msg);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setSelectedMessage(null);
    };
    const getStatusList = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/status/list`;
            const res = await fetchWrapper.get(url);
            setStatusList(res?.data || res || []);
        } catch (err) {
            console.error("Failed to load status list:", err);
        }
    };
    useEffect(() => {
        getStatusList();
    }, []);


    const getStatusDetails = (statusId) => {
        return statusList.find((s) => s.status_id === statusId || s.id === statusId);
    };

    // status_id 110 isn't in the /status/list response, so getStatusDetails finds
    // nothing for it — the journey falls back to this instead of a bare "Status 110"
    // with a failure (✗) icon, since a missing msg_status reads as not-success.
    const KNOWN_STATUS_FALLBACKS = { 110: { name: 'Sent to device', msg_status: '1' } };


    const getStatusColor = (statusName) => {
        const name = statusName?.toLowerCase() || "";
        if (name.includes("read") || name.includes("delivered")) return "green";
        if (name.includes("sent")) return "blue";
        if (name.includes("fail") || name.includes("undeliverable")) return "red";
        if (name.includes("accept")) return "green";
        return "gray";
    };

    const regexCheckHtml = /<[^>]*>/;

    const getIntervalLabel = (interval) => {
        switch (interval) {
            case 30000:
                return "30s";
            case 60000:
                return "1m";
            case 300000:
                return "5m";
            default:
                return "OFF";
        }
    };
    const handleViewPayload = (payload) => {
        const parsedPayload = JSON.parse(JSON.stringify(payload, (key, value) => {
            if (typeof value === "string" && value.startsWith("{") && value.endsWith("}")) {
                try {
                    return JSON.parse(value);
                } catch {
                    return value;
                }
            }
            return value;
        }));

        const formatted = JSON.stringify(parsedPayload, null, 2);
        setSelectedPayload(formatted);
        onPayloadOpen();

        // Highlight JSON syntax
        setTimeout(() => Prism.highlightAll(), 0);
    };


    const downloadCSV = async () => {
        try {
            setIsDownloading(true);

            const params = new URLSearchParams();
            params.append("customer_id", customer_id || "");

            if (appliedChannel?.value) params.append("channel", appliedChannel.value);
            if (appliedStatus?.value) params.append("status", appliedStatus.value);
            if (appliedStartDate) params.append("start_date", moment(appliedStartDate).format("YYYY-MM-DD"));
            if (appliedEndDate) params.append("end_date", moment(appliedEndDate).format("YYYY-MM-DD"));
            if (debouncedSearchValue.trim()) params.append("search", debouncedSearchValue.trim());

            const constructedUrl = `${process.env.REACT_APP_API_URL}/msg-log/export-data?${params.toString()}`;

            // 👇 Important: Tell axios to expect a blob (binary file)
            const response = await API.get(constructedUrl, {
                headers: getApiHeaders(),
                responseType: "blob",
            });

            // 👇 Create a downloadable link
            const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `messages_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error exporting CSV:", error);
            toast({
                title: "Export Failed",
                description: "Something went wrong while downloading the CSV file.",
                status: "error",
                duration: 4000,
                isClosable: true,
            });
        } finally {
            setIsDownloading(false);
        }
    };


    const params = location.pathname.replace('/', "")




    // Update the early return to show table structure with loader:

    if (loading) {
        return (




            <Box border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
                <Box overflowX="auto">
                <Table style={{ minWidth: '900px' }}>
                    <Thead>
                        <Tr>
                            <Th minW="120px">Message ID</Th>
                            <Th minW="150px">Recipient</Th>
                            <Th minW="300px">Message</Th>
                            <Th minW="130px">Channel</Th>
                            <Th minW="200px">Date & Time</Th>
                            <Th minW="130px">Status</Th>
                        </Tr>
                    </Thead>

                    <Tbody>
                        <Tr>
                            <Td colSpan={6} textAlign="center" py={8}>
                                <Center h="400px">
                                    <VStack spacing={3}>
                                        <Spinner size="xl" color="blue.500" thickness="4px" />
                                        <Text fontSize="sm" color="gray.600" fontWeight="medium">
                                            Loading messages...
                                        </Text>
                                    </VStack>
                                </Center>
                            </Td>
                        </Tr>
                    </Tbody>
                </Table>
                </Box>
            </Box>


        );
    }

    const getTypeId = (typeId) => {
        switch (typeId) {
            case 1:
                return "Authentication";
            case 2:
                return "Transactional";
            case 3:
                return "Marketing";
            case 4:
                return "Informational";
            default:
                return "Unknown";
        }
    }
    return (
        <>












            <Box border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
                <Box overflowX="auto">
                <Table style={{ minWidth: '900px' }}>
                    <Thead>
                        <Tr>
                            <Th minW="120px">Message ID</Th>
                            <Th minW="150px">Recipient</Th>
                            <Th minW="300px">Message</Th>
                            <Th minW="130px">Channel</Th>
                            <Th minW="200px">Date & Time</Th>
                            <Th minW="130px">Status</Th>
                        </Tr>
                    </Thead>

                    <Tbody>
                        {list.length === 0 ? <Tr>
                            <Td colSpan={6} textAlign="center" py={8}>
                                <Center h="400px">
                                    <VStack spacing={3}>
                                        <Icon as={LuInbox} boxSize={12} color="gray.300" />
                                        <Text fontSize="md" fontWeight="medium" color="gray.500">
                                            No Messages Found
                                        </Text>
                                        <Text fontSize="sm" color="gray.400" textAlign="center">
                                            No messages have been sent to this contact yet
                                        </Text>
                                    </VStack>
                                </Center>
                            </Td>
                        </Tr> :
                            list.map((item) => (
                                <Tr key={item._id}>
                                    <Td
                                        whiteSpace="nowrap"
                                        color="var(--brand-primary)"
                                        cursor="pointer"
                                        onClick={() => openModal(item)}
                                        _hover={{ textDecoration: "underline" }}
                                    >
                                        <HStack spacing={1}>
                                            <Text>{item._id.slice(0, 8)}...</Text>
                                            <ExternalLinkIcon />
                                        </HStack>
                                    </Td>

                                    <Td whiteSpace="nowrap">{item.to || "—"}</Td>

                                    <Td
                                        maxW="400px"
                                        whiteSpace="nowrap"
                                        overflow="hidden"
                                        textOverflow="ellipsis"
                                        title={regexCheckHtml.test(item.message) ? null : item.message}
                                    >
                                        {regexCheckHtml.test(item.message) ? (
                                            // Same reasoning as the journey modal below: this backend
                                            // masks every digit to ****, so rendering the stored body
                                            // inline (or in an iframe) shows broken markup. Route to
                                            // EmailPreviewModal, which offers the source template instead.
                                            <Text
                                                color="var(--brand-primary)"
                                                cursor="pointer"
                                                isTruncated
                                                textDecoration="underline"
                                                onClick={() =>
                                                    setHtmlPreview({
                                                        to: item.to,
                                                        body: decodeHtmlEntities(item.message),
                                                        templateId: item.message_template_id,
                                                    })
                                                }
                                            >
                                                This message contains HTML. Click to preview.
                                            </Text>
                                        ) : (
                                            item.message || "—"
                                        )}

                                    </Td>
                                    <Td>
                                        {(() => {
                                            const channel =
                                                Channels.find((c) => c.id === item?.MsgChannel?.id) ||
                                                Channels.find((c) => c.name === item?.MsgChannel?.name);
                                            const IconComp = channel?.icon || FaMobileAlt;
                                            const color = channel?.color || "gray";

                                            return (
                                                <HStack spacing={2}>
                                                    <Icon as={IconComp} color={`${color}`} boxSize={4} />
                                                    <Text fontSize="sm" fontWeight="thin">
                                                        {channel?.name === "In-App Notification" ? "In-App" : channel?.name || "N/A"}

                                                    </Text>
                                                </HStack>
                                            );
                                        })()}

                                        <Text fontSize={"xs"}>{getChannelInfo(item?.msg_channel_id).name === "SMS" ? `Count: ${item?.message_count}` : ""}</Text>
                                    </Td>







                                    <Td whiteSpace="nowrap" verticalAlign="top">
                                        <VStack align="flex-start" spacing={0}>
                                            <Text color="black" fontSize="xs">
                                                Received:{" "}

                                                {moment
                                                    .utc(item.receive_date)
                                                    .tz(getUserTimeZone())
                                                    .format("DD MMM YY hh:mm:ss A")}

                                            </Text>
                                            <Text color="black" fontSize="xs">
                                                Sent:{" "}
                                                {moment
                                                    .utc(item.sent_date)
                                                    .tz(getUserTimeZone())
                                                    .format("DD MMM YY hh:mm:ss A")}
                                            </Text>
                                        </VStack>
                                    </Td>



                                    <Td>
                                        <HStack spacing={2}>
                                            <HStack
                                                spacing={1}
                                                justify="center"
                                                border="1px solid"
                                                borderColor={`${item?.Status?.color || "gray"}.200`}
                                                bg={`${item?.Status?.color || "gray"}.50`}
                                                px={2}
                                                py={0.5}
                                                borderRadius="md"
                                                display="inline-flex"
                                            >
                                                <Text
                                                    fontSize="xs"
                                                    color={`${item?.Status?.color || "gray"}.600`}
                                                    fontWeight="medium"
                                                >
                                                    {item?.Status?.name || "Unknown"}
                                                </Text>
                                            </HStack>
                                            {(item?.Status?.name?.toLowerCase().includes("fail") || item?.Status?.name?.toLowerCase().includes("undeliverable")) && (
                                                <Tooltip label="View error details" hasArrow>
                                                    {/* Plain info glyph — the status pill beside it
                                                        already carries the failure colour. */}
                                                    <Box
                                                        as="span"
                                                        display="inline-flex" alignItems="center"
                                                        cursor="pointer" color="red.500"
                                                        _hover={{ color: 'red.600' }}
                                                        onClick={() => { setSelectedErrorLog(item.error_log); onErrorLogOpen(); }}
                                                    >
                                                        <Icon as={LuInfo} boxSize={4} />
                                                    </Box>
                                                </Tooltip>
                                            )}
                                        </HStack>
                                    </Td>
                                </Tr>
                            ))}
                    </Tbody>
                </Table>
                </Box>

                {totalItems > 0 && (
                    <Flex justify="center" mt={6}>
                        <Pagination
                            activePage={activePage}
                            itemsCountPerPage={25}
                            totalItemsCount={totalItems}
                            pageRangeDisplayed={5}
                            onChange={(page) => setActivePage(page)}
                            itemClass="page-item"
                            linkClass="page-link"
                            innerClass="pagination"
                        />
                    </Flex>
                )}
            </Box>





            <Modal isOpen={isOpen} onClose={closeModal} size="xl" isCentered>
                <ModalOverlay />
                <ModalContent maxW="600px">
                    <ModalHeader
                        borderBottom="1px"
                        borderColor="gray.200"
                        pb={3}
                        fontSize="lg"
                        fontWeight="semibold"
                    >
                        <HStack spacing={2}>
                            <Icon as={TimeIcon} color="blue.500" />
                            <Text>Message Delivery Journey</Text>
                        </HStack>
                    </ModalHeader>
                    <ModalCloseButton />

                    <ModalBody py={4}>
                        {selectedMessage ? (
                            <VStack align="stretch" spacing={4}>
                                {/* Message ID */}
                                <Box bg="gray.50" borderRadius="md">
                                    <Box bg="red.50" boxShadow="sm" borderRadius="lg" border={1} borderColor="red.200" borderStyle="solid" mb={2}>
                                        <Text fontSize="xs" color="black" p={2}>
                                            <Flex justifyContent={"space-between"} alignItems={"center"}>
                                                <strong> Message Id: {selectedMessage.messageid || selectedMessage._id}</strong>


                                                {/* <Button size={"xs"} bg={"rgb(var(--brand-primary-rgb) / 0.902)"} color={"white"} onClick={() => handleViewPayload(selectedMessage.customer_payload)}>View Payload</Button> */}

                                            </Flex>
                                        </Text>
                                    </Box>
                                    <Text fontSize="sm" color="gray.600">
                                        Complete delivery timeline showing channel-specific status
                                        progression and auto-failover attempts.
                                    </Text>
                                </Box>

                                {/* Info Grid */}
                                <Box
                                    bg="blue.50"
                                    border="1px"
                                    borderColor="blue.200"
                                    borderRadius="md"
                                    p={3}
                                >
                                    <Flex justify="space-between" mb={2}>
                                        <Box flex="1">
                                            <Text fontSize="xs" color="gray.600" mb={1}>
                                                Recipient
                                            </Text>
                                            <Text fontSize="xs" fontWeight="semibold">
                                                {selectedMessage.to || "-"}
                                            </Text>
                                        </Box>
                                        <Box flex="1">
                                            <Text fontSize="xs" color="gray.600" mb={1}>
                                                Message Type
                                            </Text>
                                            <Tag fontSize="xs" fontWeight="normal" border={"1px"} borderColor="gray.300"
                                                color={"black"}
                                                bg="white">
                                                {getTypeId(selectedMessage.message_type_id)}

                                            </Tag>
                                        </Box>
                                        <Box flex="1">
                                            <Text fontSize="xs" color="gray.600" mb={1}>
                                                Final Status
                                            </Text>
                                            <Badge
                                                colorScheme={getStatusColor(selectedMessage?.Status?.name)}
                                                px={2}
                                                py={1}
                                                borderRadius="md"
                                            >
                                                {selectedMessage?.Status?.name || "Unknown"}
                                            </Badge>
                                        </Box>


                                    </Flex>
                                    <Box>
                                        {selectedMessage.message && (
                                            <>
                                                <Text fontSize="xs" color="gray.600" mb={2} fontWeight="medium">
                                                    Message Content
                                                </Text>
                                                <Box bg="white" border={1} borderColor={"gray.100"} p={3} borderRadius="md">
                                                    {regexCheckHtml.test(selectedMessage.message) ? (
                                                        // The log pipeline masks every digit in the stored body to ****,
                                                        // which destroys HTML beyond repair (borders, padding, image
                                                        // URLs). Route to EmailPreviewModal, which offers the source
                                                        // template — the only accurate render of this message.
                                                        <Flex align="center" justify="space-between" gap={3} flexWrap="wrap">
                                                            <Text fontSize="sm" color="gray.600">
                                                                HTML email content · {selectedMessage.message.length.toLocaleString()} characters
                                                            </Text>
                                                            <Button
                                                                size="sm"
                                                                variant="outline"
                                                                flexShrink={0}
                                                                onClick={() =>
                                                                    setHtmlPreview({
                                                                        to: selectedMessage.to,
                                                                        body: decodeHtmlEntities(selectedMessage.message),
                                                                        templateId: selectedMessage.message_template_id,
                                                                    })
                                                                }
                                                            >
                                                                Preview HTML
                                                            </Button>
                                                        </Flex>
                                                    ) : <Text fontSize="sm">{selectedMessage.message}</Text>}

                                                </Box>
                                            </>
                                        )}

                                    </Box>

                                </Box>



                                <Box>
                                    <HStack spacing={2} mb={3}>
                                        <Icon as={TimeIcon} color="blue.500" boxSize={4} />
                                        <Text fontSize="sm" fontWeight="semibold">
                                            Delivery Timeline & Status Progression
                                        </Text>
                                    </HStack>

                                    <VStack align="stretch" spacing={0} pl={2}>
                                        {selectedMessage.history?.map((h, i) => {
                                            const status = getStatusDetails(h.status_id);
                                            const statusFallback = KNOWN_STATUS_FALLBACKS[h.status_id];
                                            const displayStatusName =
                                                status?.name || statusFallback?.name || `Status ${h.status_id}`;
                                            const isSuccessStatus =
                                                (status?.msg_status ?? statusFallback?.msg_status) === "1";


                                            const { name: channelName, icon: ChannelIcon, color: channelColor } = getChannelInfo(h.channel_id);



                                            const isFailed = status?.name?.toLowerCase().includes("fail") ||
                                                status?.name?.toLowerCase().includes("undeliverable");


                                            const currentIndex = selectedMessage.history.findIndex((item) => item === h);
                                            const nextStatus = selectedMessage.history[currentIndex + 1];
                                            const nextStatusDetails = nextStatus ? getStatusDetails(nextStatus.status_id) : null;

                                            const isNextNotFailed =
                                                nextStatusDetails &&
                                                !nextStatusDetails?.name?.toLowerCase().includes("fail") &&
                                                !nextStatusDetails?.name?.toLowerCase().includes("undeliverable");


                                            const shouldTriggerFailover = isFailed && isNextNotFailed;


                                            const getCooloredStatus = (status) => {
                                                if (!status) return "white";
                                                const name = status.name?.toLowerCase() || "";

                                                if (name.includes("read") || name.includes("delivered")) return "#f0fdf4";
                                                if (name.includes("sent")) return "var(--brand-tint)";
                                                if (name.includes("clicked")) return "#f0fdf4";
                                                if (name.includes("fail") || name.includes("undeliverable")) return "#fef2f2";
                                                if (name.includes("invalid") || name.includes("undeliverable")) return "#fef2f2";
                                                if (name.includes("accept")) return "white";
                                                return "white";
                                            }
                                            const getCooloredBorderedStatus = (status) => {
                                                if (!status) return "gray";
                                                const name = status.name?.toLowerCase() || "";

                                                if (name.includes("read") || name.includes("delivered")) return "#00c951";
                                                if (name.includes("clicked") || name.includes("delivered")) return "#00c951";
                                                if (name.includes("sent")) return "#2b7fff";
                                                if (name.includes("fail") || name.includes("undeliverable")) return "#fb2c36";
                                                if (name.includes("invalid") || name.includes("undeliverable")) return "#fb2c36";
                                                if (name.includes("accept")) return "#6a7282";
                                                return "gray";
                                            }

                                            return (
                                                <Flex key={i}>
                                                    <Box
                                                        flex="1"
                                                        bg={getCooloredStatus(status)}
                                                        border="1px"
                                                        borderColor={getCooloredStatus(status)}
                                                        borderLeftWidth="4px"
                                                        borderLeftColor={getCooloredBorderedStatus(status)}
                                                        borderRadius="md"
                                                        my={3}
                                                        px={2}
                                                        py={5}
                                                    >
                                                        {/* ✅ Left icon + Right content */}
                                                        <Flex align="start" gap={3}>
                                                            {/* Left icon */}
                                                            {isSuccessStatus ? (
                                                                <FiCheckCircle color="#00a63e" boxSize={4} />
                                                            ) : (
                                                                <FiXCircle color="#e7000b" boxSize={4} />
                                                            )}

                                                            {/* Right content */}
                                                            <Box flex="1">
                                                                <Flex justify="space-between" align="start" mb={1}>
                                                                    <HStack spacing={2}>
                                                                        {h.channel_id ? (
                                                                            <HStack spacing={1}>
                                                                                <Icon as={ChannelIcon} color={`${channelColor}`} boxSize={3.5} />
                                                                                <Text fontSize="xs" fontWeight="semibold">
                                                                                    {channelName}
                                                                                </Text>
                                                                            </HStack>
                                                                        ) : (
                                                                            <Text fontSize="xs" fontWeight="semibold">
                                                                                {channelName}
                                                                            </Text>
                                                                        )}
                                                                        {status?.msg_status === "0" && <Tag bg={"red"} size={"sm"} color={"white"}>Failed</Tag>}
                                                                        <Tag
                                                                            size="sm"
                                                                            border="1px solid"
                                                                            borderColor="gray.300"
                                                                            color={status?.name?.toLowerCase().includes("accept") ? "black" : "#64748b"}
                                                                            bg="transparent"
                                                                        >
                                                                            {displayStatusName}
                                                                        </Tag>
                                                                    </HStack>

                                                                    <Text fontSize="xs" color="gray.500">
                                                                        {new Date(h.time).toLocaleString("en-PK", {
                                                                            dateStyle: "short",
                                                                            timeStyle: "medium",
                                                                        })}
                                                                    </Text>
                                                                </Flex>
                                                                {(h.channel_id === 5 || h.channel_id === 6) && (
                                                                    <Text fontSize="xs" color="gray.600">Subscriber Id : {h.subscriber_id || '-'}</Text>
                                                                )}
                                                                {h.status_id === 110 && (
                                                                    <Text fontSize="xs" color="gray.600">Message Sent to device</Text>
                                                                )}
                                                                {isFailed ? (
                                                                    <Button
                                                                        size="xs"
                                                                        variant="outline"
                                                                        colorScheme="red"
                                                                        leftIcon={<WarningIcon />}
                                                                        mt={1}
                                                                        onClick={() => {
                                                                            // History entries rarely carry their own error_log — the
                                                                            // real payload almost always lives on the top-level message.
                                                                            setSelectedErrorLog(h.error_log || selectedMessage?.error_log);
                                                                            onErrorLogOpen();
                                                                        }}
                                                                    >
                                                                        Message Undeliverable — View Error Details
                                                                    </Button>
                                                                ) : (
                                                                    <Text fontSize="xs" color="gray.600">
                                                                        {status?.description ||
                                                                            (status?.name === "Message Accepted"
                                                                                ? "Message Accepted - Request received and validated"
                                                                                : status?.name === "Message Sent"
                                                                                    ? `Message Sent to ${channelName}`
                                                                                    : status?.name === "Message Delivered"
                                                                                        ? "Message Delivered"
                                                                                        : status?.name === "Message Read"
                                                                                            ? "Message Read"
                                                                                            : "")}
                                                                    </Text>
                                                                )}

                                                                {shouldTriggerFailover && (
                                                                    <Text
                                                                        fontSize="xs"
                                                                        color="#ca3500"
                                                                        bg="#ffedd4"
                                                                        px={2}
                                                                        py={1}
                                                                        mt={2}
                                                                        borderRadius="md"
                                                                        fontWeight="medium"
                                                                    >
                                                                        → Triggering auto-failover to next channel
                                                                    </Text>
                                                                )}
                                                            </Box>
                                                        </Flex>
                                                    </Box>
                                                </Flex>
                                            );
                                        })}
                                    </VStack>
                                </Box>
                            </VStack>
                        ) : (
                            <Text>No details available.</Text>
                        )}
                    </ModalBody>

                    <ModalFooter borderTop="1px" borderColor="gray.200">
                        <Button onClick={closeModal} size={"sm"} bg="var(--brand-primary)"

                            color="white">
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>



            {/* Error Log Modal */}
            <Modal isOpen={isErrorLogOpen} onClose={onErrorLogClose} size="xl" isCentered>
                <ModalOverlay />
                <ModalContent maxW="700px">
                    <ModalHeader borderBottom="1px" borderColor="gray.100" pb={3}>
                        <HStack spacing={2}>
                            <Box display="inline-flex" alignItems="center" justifyContent="center"
                                w="28px" h="28px" borderRadius="full" bg="blue.50" border="1px solid" borderColor="blue.200">
                                <WarningIcon color="blue.500" boxSize={3} />
                            </Box>
                            <Text fontSize="md" fontWeight="600" color="gray.800">Error Details</Text>
                        </HStack>
                    </ModalHeader>
                    <ModalCloseButton top={3} />
                    <ModalBody py={4}>
                        {(() => {
                            const raw = selectedErrorLog;
                            if (!raw) return <Text color="gray.400" fontSize="sm">No error details available.</Text>;
                            let parsed = raw;
                            if (typeof raw === 'string') { try { parsed = JSON.parse(raw); } catch { parsed = raw; } }

                            const flattenObject = (obj, prefix = '') => {
                                if (typeof obj !== 'object' || obj === null) return { [prefix]: obj };
                                return Object.entries(obj).reduce((acc, [key, val]) => {
                                    const newKey = prefix ? `${prefix}.${key}` : key;
                                    if (val !== null && typeof val === 'object' && !Array.isArray(val)) {
                                        Object.assign(acc, flattenObject(val, newKey));
                                    } else { acc[newKey] = val; }
                                    return acc;
                                }, {});
                            };

                            const renderValue = (val) => {
                                if (typeof val === 'boolean') return (
                                    <Tag size="sm" borderRadius="full" bg={val ? '#dcfce7' : '#fee2e2'} color={val ? '#16a34a' : '#dc2626'}>{String(val)}</Tag>
                                );
                                if (val === null || val === undefined) return <Text fontSize="sm" color="gray.400">—</Text>;
                                if (Array.isArray(val)) return <Text fontSize="sm" color="gray.700">{JSON.stringify(val)}</Text>;
                                return <Text fontSize="sm" color="gray.700">{String(val)}</Text>;
                            };

                            const flatData = Array.isArray(parsed)
                                // A single-item array (the overwhelmingly common case) doesn't need an
                                // "[0]." prefix on every key — it only exists to disambiguate multiple
                                // items, and otherwise just makes keys longer and harder to read.
                                ? (parsed.length === 1
                                    ? flattenObject(parsed[0])
                                    : parsed.reduce((acc, item, i) => Object.assign(acc, flattenObject(item, `[${i}]`)), {}))
                                : typeof parsed === 'object' ? flattenObject(parsed) : { value: parsed };

                            // "value" as a raw key (e.g. a bounce webhook's `{ value: "Bounce" }`) reads
                            // better to a customer as "Reason" — display-only relabel, key untouched.
                            const displayKey = (key) => (key.toLowerCase() === 'value' ? 'Reason' : key);

                            return (
                                <TableContainer border="1px" borderColor="gray.200" borderRadius="md">
                                    <Table variant="simple" size="sm" tableLayout="fixed">
                                        <Thead bg="gray.50">
                                            <Tr>
                                                <Th py={3} fontSize="xs" color="gray.700" fontWeight="700" w="180px">Key</Th>
                                                <Th py={3} fontSize="xs" color="gray.700" fontWeight="700">Value</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {Object.entries(flatData).map(([key, val]) => (
                                                <Tr key={key} _hover={{ bg: 'gray.50' }}>
                                                    <Td py={3} fontSize="sm" color="gray.600" borderColor="gray.100" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" title={key}>{displayKey(key)}</Td>
                                                    <Td py={3} borderColor="gray.100" wordBreak="break-word" whiteSpace="normal">{renderValue(val)}</Td>
                                                </Tr>
                                            ))}
                                        </Tbody>
                                    </Table>
                                </TableContainer>
                            );
                        })()}
                    </ModalBody>
                    <ModalFooter borderTop="1px" borderColor="gray.100">
                        <Button onClick={onErrorLogClose} size="sm" bg="var(--brand-primary)" color="white" _hover={{ bg: 'var(--brand-primary-hover)' }}>Close</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal isOpen={isPayloadOpen} onClose={onPayloadClose} size="4xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Payload Details</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {selectedPayload ? (
                            <Box
                                maxH="400px"
                                overflowY="auto"
                                // bg="gray.900"
                                color="green.200"
                                // p={4}
                                borderRadius="md"
                            >
                                <pre
                                    style={{
                                        backgroundColor: "black",
                                        textShadow: "none",
                                        color: "white",
                                        padding: "0px",
                                        borderRadius: "8px",
                                        fontFamily: "monospace",

                                    }}
                                >
                                    <span
                                        style={{
                                            padding: 15,
                                            backgroundColor: "#2F2F2F",
                                            fontSize: "14px",
                                            display: "block",
                                            marginBottom: "10px",

                                        }}
                                    >
                                        json
                                    </span>

                                    <code
                                        className="language-json"
                                        style={{ padding: "0px 15px 15px", display: "block", whiteSpace: "pre-wrap" }}
                                        dangerouslySetInnerHTML={{ __html: Prism.highlight(selectedPayload, Prism.languages.json, 'json') }}
                                    />
                                </pre>

                            </Box>
                        ) : (
                            <Text>No payload found.</Text>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={onPayloadClose} size={"sm"} bg="var(--brand-primary)"

                            color="white">Close</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* HTML message body, opened from the Message column or the journey modal.
                Rendered in the shared sandboxed-iframe modal so the email displays at
                full size and its CSS cannot leak into the app. */}
            <EmailPreviewModal
                isEmailPreviewOpen={!!htmlPreview}
                onEmailPreviewClose={() => setHtmlPreview(null)}
                title={htmlPreview?.fromTemplate ? "Message Preview — source template" : "Message Preview"}
                subjectLabel="Recipient:"
                subject={htmlPreview?.to || ''}
                body={htmlPreview?.body}
                onFallbackPreview={
                    htmlPreview?.templateId && !htmlPreview?.fromTemplate
                        ? () => loadTemplatePreview(htmlPreview.templateId)
                        : undefined
                }
                fallbackLabel={`Preview template #${htmlPreview?.templateId} instead`}
                fallbackLoading={templatePreviewLoading}
                fallbackNote={
                    htmlPreview?.fromTemplate
                        ? 'Showing the source template, not the delivered message — variables are unsubstituted and later template edits will show through.'
                        : undefined
                }
            />

        </>
    )
}
